import { useRef, useState } from "react";
import { Upload, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fileUrl } from "../lib/api";

export const ImageUpload = ({ value, onChange, testid = "image-upload", label = "Enviar imagem", round, wide, video }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post("/upload", fd);
      onChange(data.path);
      toast.success(video ? "Vídeo enviado" : "Imagem enviada");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };
  const box = wide ? "h-28 w-full" : "h-24 w-24";
  return (
    <div className="flex items-center gap-3">
      <button type="button" data-testid={testid} onClick={() => ref.current?.click()}
        className={`relative flex ${box} items-center justify-center overflow-hidden border border-dashed border-[#232B3E] bg-[#0B0E14] hover:border-[#E4F222] ${round ? "rounded-full" : "rounded-xl"}`}>
        {busy ? <Loader2 className="h-5 w-5 animate-spin text-[#E4F222]" /> : value ? (video
          ? <video src={fileUrl(value)} muted autoPlay loop playsInline className="h-full w-full object-cover" />
          : <img src={fileUrl(value)} alt="" className={`h-full w-full ${wide ? "object-cover" : "object-contain"}`} />
        ) : (
          <div className="flex flex-col items-center gap-1 text-[11px] text-[#94A3B8]"><Upload className="h-5 w-5" />{label}</div>
        )}
      </button>
      {value && (
        <button type="button" data-testid={`${testid}-clear`} onClick={() => onChange(null)} className="text-[#94A3B8] hover:text-red-400">
          <X className="h-4 w-4" />
        </button>
      )}
      <input ref={ref} type="file" accept={video ? "video/*" : "image/*"} className="hidden" onChange={pick} />
    </div>
  );
};
